// This icon file is generated automatically.
var PBoldOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M9.9 5.52c.53-.54.85-1.28.85-2.1v-.16A3.06 3.06 0 007.68.22H3.05c-.23 0-.42.2-.42.43v10.6c0 .26.2.47.46.47h4.98a3.3 3.3 0 003.3-3.29v-.17c0-1.14-.58-2.15-1.47-2.74zm-5.78-3.8h3.52c.89 0 1.61.7 1.61 1.55v.15c0 .86-.72 1.55-1.61 1.55H4.13V1.72zm5.73 6.7c0 1-.8 1.79-1.8 1.79H4.12V6.48h3.93c1 0 1.8.8 1.8 1.78v.17z", "fill-rule": "nonzero" } }] }, "name": "p-bold", "theme": "outlined" };
export default PBoldOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PBoldOutlined.js
// module id = 3245
// module chunks = 0